import { Action } from "@ngrx/store";
import { Plan } from "./plan.model";
import { type } from "../../util";
import { Patient } from "../patient/patient.model";

/**
 * Action Types
 */
export const ActionTypes = {
  ADD: type("[Plan] Add"),
  ADD_SUCCESS: type("[Plan] Add Success"),
  ADD_FAIL: type("[Plan] Add Fail"),
  LIST: type("[Plan] List"),
  LIST_COMPLETE: type("[Plan] List Complete"),
  LIST_FAIL: type("[Plan] List Fail"),
  FILTER_BY_NAME: type("[Plan] Filter by Name"),
  FILTER_BY_PATIENT: type("[Plan] Filter by Patient"),
  LOAD: type("[Plan] Load"),
  LOAD_SUCCESS: type("[Plan] Load Success"),
  LOAD_FAIL: type("[Plan] Load Fail"),
  UPDATE: type("[Plan] Update"),
  UPDATE_SUCCESS: type("[Plan] Update Success"),
  UPDATE_FAIL: type("[Plan] Update Fail"),
  DELETE: type("[Plan] Delete"),
  DELETE_SUCCESS: type("[Plan] Delete Success"),
  DELETE_FAIL: type("[Plan] Delete Fail"),
  DUPLICATE: type("[Plan] Duplicate"),
  DUPLICATE_SUCCESS: type("[Plan] Duplicate Success"),
  DUPLICATE_FAIL: type("[Plan] Duplicate Fail"),
};

/**
 * Actions
 */
export class AddPlanAction implements Action {
  type = ActionTypes.ADD;
  constructor(public payload: Plan) {}
}

export class AddPlanSuccessAction implements Action {
  type = ActionTypes.ADD_SUCCESS;
  constructor(public payload: Plan) {}
}

export class AddPlanFailAction implements Action {
  type = ActionTypes.ADD_FAIL;
  constructor(public payload?: any) {}
}

export class ListPlansAction implements Action {
  type = ActionTypes.LIST;
}

export class ListPlansCompleteAction implements Action {
  type = ActionTypes.LIST_COMPLETE;
  constructor(public payload: Plan[]) {}
}

export class ListPlansFailAction implements Action {
  type = ActionTypes.LIST_FAIL;
  constructor(public payload?: any) {}
}

export class FilterPlansByNameAction implements Action {
  type = ActionTypes.FILTER_BY_NAME;
  constructor(public payload?: string) {}
}

export class FilterPlansByPatientAction implements Action {
  type = ActionTypes.FILTER_BY_PATIENT;
  constructor(public payload?: Patient) {}
}

export class LoadPlanAction implements Action {
  type = ActionTypes.LOAD;
  constructor(public payload: Plan) {}
}

export class LoadPlanSuccessAction implements Action {
  type = ActionTypes.LOAD_SUCCESS;
  constructor(public payload: Plan) {}
}

export class LoadPlanFailAction implements Action {
  type = ActionTypes.LOAD_FAIL;
  constructor(public payload?: any) {}
}

export class UpdatePlanAction implements Action {
  type = ActionTypes.UPDATE;
  constructor(public payload: Plan) {}
}

export class UpdatePlanSuccessAction implements Action {
  type = ActionTypes.UPDATE_SUCCESS;
  constructor(public payload: Plan) {}
}

export class UpdatePlanFailAction implements Action {
  type = ActionTypes.UPDATE_FAIL;
  constructor(public payload?: any) {}
}

export class DeletePlanAction implements Action {
  type = ActionTypes.DELETE;
  constructor(public payload: Plan) {}
}

export class DeletePlanSuccessAction implements Action {
  type = ActionTypes.DELETE_SUCCESS;
  constructor(public payload: Plan) {}
}

export class DeletePlanFailAction implements Action {
  type = ActionTypes.DELETE_FAIL;
  constructor(public payload?: any) {}
}

export class DuplicatePlanAction implements Action {
  type = ActionTypes.DUPLICATE;
  constructor(public payload: Plan) {}
}

export class DuplicatePlanSuccessAction implements Action {
  type = ActionTypes.DUPLICATE_SUCCESS;
  constructor(public payload: Plan) {}
}

export class DuplicatePlanFailAction implements Action {
  type = ActionTypes.DUPLICATE_FAIL;
  constructor(public payload?: any) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Action =
  | AddPlanAction
  | AddPlanSuccessAction
  | AddPlanFailAction
  | ListPlansAction
  | ListPlansCompleteAction
  | ListPlansFailAction
  | FilterPlansByNameAction
  | FilterPlansByPatientAction
  | LoadPlanAction
  | LoadPlanSuccessAction
  | LoadPlanFailAction
  | UpdatePlanAction
  | UpdatePlanSuccessAction
  | UpdatePlanFailAction
  | DeletePlanAction
  | DeletePlanSuccessAction
  | DeletePlanFailAction
  | DuplicatePlanAction
  | DuplicatePlanSuccessAction
  | DuplicatePlanFailAction;



// WEBPACK FOOTER //
// /app/src/app/core/store/plan/plan.actions.ts